import { render } from "./ModalAlert.vue?vue&type=template&id=19095e49&scoped=true&ts=true"
import script from "./ModalAlert.vue?vue&type=script&lang=ts"
export * from "./ModalAlert.vue?vue&type=script&lang=ts"

import "./ModalAlert.vue?vue&type=style&index=0&id=19095e49&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19095e49"]])

export default __exports__